import React from 'react';

class DialogRow extends React.Component {
    render() {
        const {
            label,
            value = '',
            children = null,
            classes = ''
        } = this.props;

        return (
            <div className={`dialog-row ${classes}`}>
                <div className="dialog-row-title">{label}</div>
                {children &&
                    <div className="dialog-row-value">{children}</div>
                }
                {!children &&
                    <div className="dialog-row-value">{value}</div>
                }
            </div>
        );
    }
}

export default DialogRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogRow.js